//import { EnumTypeResponse } from 

export class ResponseResult {
    typeResponse: any;
    message: string;
    data: any;
    requestTime: number;
}
